export default __webpack_public_path__ + "static/media/logo2.72f18172.png";